import UserPreferences from './UserPreferences.tsx';

export default UserPreferences;
